import { render, staticRenderFns } from "./BlogDetail.vue?vue&type=template&id=208f035a&"
import script from "./BlogDetail.vue?vue&type=script&lang=js&"
export * from "./BlogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports